
import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end justify-center bg-black/60 backdrop-blur-sm sm:items-center sm:p-4"
      onClick={onClose}
    >
      <div 
        className="flex max-h-[100dvh] min-h-[70dvh] w-full flex-col overflow-hidden bg-white text-gray-900 shadow-2xl transition-all dark:bg-slate-950 dark:text-slate-100 sm:min-h-0 sm:max-h-[90vh] sm:max-w-2xl sm:rounded-2xl lg:max-w-3xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="z-10 flex items-start justify-between border-b border-gray-100 bg-white px-4 py-4 dark:border-slate-800 dark:bg-slate-950 sm:items-center sm:rounded-t-2xl sm:px-6 sm:py-5">
          <h2 className="pr-4 text-lg font-black uppercase tracking-tight text-gray-900 dark:text-slate-100 sm:text-xl">{title}</h2>
          <button 
            onClick={onClose} 
            className="rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-slate-500 dark:hover:bg-slate-800 dark:hover:text-slate-100"
            aria-label="Close modal"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex-grow overflow-y-auto px-4 py-4 sm:p-6">
          {children}
        </div>
      </div>
    </div>
  );
};
